import { Value } from '@sinclair/typebox/value';
import type { ApiError } from '@lotta/shared/types-lottery-api';
import { ApiErrorSchema } from '@lotta/shared/types-lottery-api';

export const isApiError = (error: unknown): error is ApiError => Value.Check(ApiErrorSchema, error);
